export default __webpack_public_path__ + "static/blob9-379ef22da744ae75c0b1f851aab2c827.svg";